<template>
  <div :class="['sidebar', (active ? 'is-active' : '')]">
    <div class="login">{{ t('Login') }}</div>
    <div @click="loggleMenu()" :class="['c-hamburger', 'c-hamburger--htla']">
      <span></span>
    </div>
    <div class="langs">
      <span>ENG</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'active'
  ],

  data () {
    return {
      isActive: this.active
    }
  },

  methods: {
    loggleMenu () {
      this.$emit('loggleMenu')
    }
  },

  watch: {
    active (val) {
      this.isActive = val
    }
  }
}
</script>

<style lang="scss">
.main > .sidebar {
  .menu-open {
    &:hover {
      background-color: rgba(86, 204, 242, 0.5);
    }
  }
}

.sidebar {
    width: 0px;
    // border-left: 1px solid white;
    width: 100px;
    padding: 30px 0px;
    display: flex;
    z-index: 1;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    right: 0px;
    top: 0px;
    bottom: 0px;
    .login {
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
      cursor: pointer;
    }
    .c-hamburger {
      display: block;
      position: relative;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 96px;
      font-size: 0;
      text-indent: -9999px;
      cursor: pointer;
      appearance: none;
      box-shadow: none;
      border-radius: none;
      border: none;
      opacity: 0;
      transition: all 2.8s cubic-bezier(.19,1,.22,.95) .1s;
      -ms-transform: translateX(-50px) skewX(-60deg);
      transform: translateX(-50px) skewX(-60deg);
      opacity: 1;
      transform: translateX(0) skewX(0);
      span {
        display: block;
        position: absolute;
        top: 44px;
        left: 0px;
        right: 0px;
        height: 1px;
        width: 45px;
        margin: 0 auto;
        background: #fff;
        transition: transform .3s;
        &:before {
          transform-origin: top right;
          transition: transform .3s,width .3s,top .3s;
          position: absolute;
          display: block;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: #fff;
          content: "";
          top: -9px;
        }
        &:after {
          position: absolute;
          display: block;
          right: 0;
          width: 100%;
          height: 1px;
          background-color: #fff;
          content: "";
          bottom: -9px;
          width: 50%;
          transform-origin: bottom right;
          transition: transform .3s,width .3s,bottom .3s;
        }
      }
    }

    &.is-active {
      border-left: 1px solid #2F80ED !important;
      background-color: transparent !important;
      .c-hamburger {
        span {
          &:before {
            top: 0;
            transform: translateX(23px) translateY(1px) rotate(45deg);
            width: 50%;
          }
          &:after {
            bottom: -1px;
            transform: translateX(0px) translateY(-1px) rotate(-45deg);
            width: 50%;
          }
        }
      }
    }

    .langs {
      text-align: center;
      font-size: 12px;
      text-transform: uppercase;
      span {
        cursor: pointer;
      }
    }
  }
</style>